export const Spalvos = [
  '#2f4f4f',
  '#228b22',
  '#800000',
  '#00008b',
  '#ff8c00',
  '#2a5df7',
  '#00ff00',
  '#00ffff',
  '#ff00ff',
  '#eee8aa',
  '#6495ed',
  '#ff69b4'
];

export const PapildomosSpalvos = [
  '#7030a0', //10
  '#00b050', //6
  '#0070c0', //8
  '#ff0000', //2
  "#808000", //Olive
  '#ffc000', //3
  '#002060', //9
  '#ffff00', //4
  '#c00000', //1
  '#92d050', //5
  '#00b0f0', //7
];

export const BandosKilmesSpalvos = [
  "#800000",
  "#808000",
  "#FF0000",
  "#000080",
  "#0000FF",
  "#008080"
]

export const MultiColorMix = [
  '#7030a0', //10
  '#00b050', //6
  '#ff0000', //2
  "#0074e6",
  "#808000", //Olive
  '#002060',
  '#ff00ff',
  "#008080", //Teal
  '#ff8c00',
  '#0070c0', //8
  "#f55000",
  '#ffc000', //3
  "#00C49F",
  '#800000', //Maroon
  "#00FFFF", //Cyan
  "#e69500",
  "#635dcc",
  "#800080", //Purple

]

export const X11colors = [
  '#800000', //Maroon
  "#A52A2A", //Brown
  "#808000", //Olive
  "#FF0000", //Red
  "#008000", //Green
  "#008080", //Teal
  "#000080", //Navy
  "#00FFFF", //Cyan
  "#0000FF", //Blue
  "#800080", //Purple
  "#FF00FF", //Magenta
  "#000000", //Black
  "#808080", //Grey
]

export const Primary = '#1e56c2';

export const SpalvosProduktyvumoLinijai = [
  "#006700", //"#a95fae",
  "#e60000", //"#00C49F",
]

export const SpalvosProduktyvumoStulpeliams = [
  "#0074e6",//blue
  "#e69500"//orange
]

export const extraColors = [
  "#635dcc", // dark violet
  "#4cb373", // meh green
  "#ffac0c", // orange juice
  "#f55000", // grapefuit
  "#0074e6", // deep dark sky blue
];
export const extraColorsByChatGpt = ["#8884d8", "#82ca9d", "#ffc658", "#ff8042", "#0088fe", "#00C49F", "#FFBB28"];

export const bendrosSpalvosProduktyvumoLinijaiIrStulpeliams=[
  ...SpalvosProduktyvumoLinijai, ...SpalvosProduktyvumoStulpeliams
]


